import React, { useEffect, useState } from "react";
import { doAuthenticate } from "../crud/avm.crud";
import Loader from "../components/Loader";
import ConsumerAvm from "../pages/consumer-avm/ConsumerAvm";
import { Grid } from "@mui/material";
import { setupAxios } from "../crud/apiConfig";
import { getRandomNumber, sendEventsInGoogleAnalytics, setUserForGa, _trackActivity } from "../resources/utils";
import {
  StyleContainer,
  StyleHeading,
  StyleTypography,
} from "../assets/js/Theme";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SvgIcon from "../components/SvgIcon";
import { injectIntl } from "react-intl";
const PrivateRoute = ({ intl, location }) => {
  const { REACT_APP_API_TOKEN_PM } = process.env;
  const [currentUser, setCurrentUser] = useState();
  const [currentSession] = useState(getRandomNumber());
  const [loading, setLoading] = useState(true);

  const _doAuth = async () => {
    try {
      const queryString = location.search;
      const sp = new URLSearchParams(queryString);
      const companyToken = sp.get("___Y29tcGFueVRva2VuX2Zyb21fY2xpZW50") || REACT_APP_API_TOKEN_PM;//base 64 of companyToken_from_client https://www.base64encode.org/
      const userToken = sp.get("___dXNlclRva2VuX2Zyb21fY2xpZW50") || "";//base 64 of userToken_from_client https://www.base64encode.org/
      const utmSource = sp.get("utm_source") || "";
      const utmMedium = sp.get("utm_medium") || "";
      const utmCampaign = sp.get("utm_campaign") || "";

      if (companyToken) {
        const queryParams = {
          companyToken,
          userToken,
          utmCampaign,
          utmMedium,
          utmSource
        };
        setLoading(true);
        const result = await doAuthenticate(queryParams);
        setLoading(false);
        const { status, data } = result.data;
        sendEventsInGoogleAnalytics(
          "authentication",
          "Login",
          `Success user authentication from companyToken: ${companyToken} and userToken: ${userToken}`
        );
        setUserForGa({ companyToken });
        setUserForGa({ userToken });
        let postParams = {
          event: "page-visit",
          action: "",
          status: "",
          context: "avm-filters-form",
          utmSource,
          utmMedium,
          utmCampaign,
          currentSession,
        };
        if (status === 1) {
          data.user_id ? (data.verified = 1) : (data.verified = 0);
          data.utmSource = utmSource
          data.utmMedium = utmMedium
          data.utmCampaign = utmCampaign
          data.userConsumerId = ""
          setCurrentUser(data);
          setupAxios(companyToken);
          postParams.action = "authorized"
          postParams.status = `An authorized access from companyToken: ${companyToken} and userToken: ${userToken}`
        } else {
          postParams.action = "unauthorized"
          postParams.status = `An unauthorized access from companyToken: ${companyToken} and userToken: ${userToken}`
          sendEventsInGoogleAnalytics(
            "authentication",
            "Login",
            `An unauthorized access from companyToken: ${companyToken} and userToken: ${userToken}`
          );
          console.log("You are not authorized to view this Page");
        }
        _trackActivity(postParams);
      } else {
        console.log("company token is empty!");
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };
  useEffect(() => {
    _doAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Loader loading={loading} />
      {currentUser ? (
        <StyleContainer maxWidth="xl">
          <div className="site-wrapper">
            <Header currentUser={currentUser} />
            <ConsumerAvm
              currentUser={currentUser}
              currentSession={currentSession}
              setCurrentUser={setCurrentUser}
            />
          </div>
          <Footer />
        </StyleContainer>
      ) : !loading ? (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={5}
          className="error--wrapper"
        >
          <Grid item xs={12} md={"auto"}>
            <SvgIcon name="unauthorized" />
          </Grid>
          <Grid item xs={12} md={"auto"}>
            <StyleHeading variant="h1" color="primary" gutterBottom>
              {intl.formatMessage({ id: "ERROR.NOT_AUTHORIZED" })}
            </StyleHeading>
            <StyleTypography variant="body1" color="primary" paragraph>
              {intl.formatMessage(
                {
                  id: "ERROR.SUPPORT_CONTACT",
                },
                {
                  email: (
                    <StyleTypography
                      variant="body1"
                      paragraph
                      component="a"
                      href={`mailto:support@propertymonitor.com`}
                    >
                      support@propertymonitor.com
                    </StyleTypography>
                  ),
                }
              )}
            </StyleTypography>
          </Grid>
        </Grid>
      ) : null}
    </>
  );
};

export default injectIntl(PrivateRoute);
